import { Charge } from "api/hooks/private/finance/GetCharge";
import RubberStamp from "components/RubberStamp/RubberStamp";
import dayjs from "dayjs";

interface PropTypes {
    charge: Charge;
}

// returns rubber stamp based on the charge status
export default function ChargeStatus({ charge }: PropTypes) {

    const baseProps = {
        transform: 'rotate(8deg)',
    };

    if (charge.voided_at) {
        return <RubberStamp color="error.main" {...baseProps}>Void</RubberStamp>;
    } else if (Number(charge.amount_paid) === Number(charge.discounted_total)) {
        return <RubberStamp color="success.main" {...baseProps}>Paid</RubberStamp>;
    } else if (charge.deposit > 0 && Number(charge.amount_paid) >= charge.deposit) {
        return <RubberStamp color="warning.main" {...baseProps}>Deposit Paid</RubberStamp>;
    } else if (charge.deposit > 0 && Number(charge.amount_paid) < charge.deposit && dayjs().isAfter(dayjs(charge.deposit_due))) {
        return <RubberStamp color="error.main" {...baseProps}>Deposit Overdue</RubberStamp>;
    } else if (Number(charge.amount_paid) < charge.amount && dayjs().isAfter(dayjs(charge.amount_due))) {
        return <RubberStamp color="error.main" {...baseProps}>Overdue</RubberStamp>;
    }

    return null;
}